export default __webpack_public_path__ + "static/media/medication_icon.de4dc3f7.svg";